module.exports = __webpack_public_path__ + "static/media/PillsImg.c7bd7c86.jpg";